import axios from 'axios'; 
axios.defaults.timeout = 500000;
import apiAddress from './apiAddress';

const domain = apiAddress;

export function fetch(url, params = {}, prefix=true) {
    // console.log(url)
    return new Promise((resolve, reject) => {
        axios.get(prefix?`${domain}${url}`:`${url}`, {params: params})
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function post(url, data) {
    return new Promise((resolve, reject) => {
        axios.post(`${domain}${url}`, JSON.stringify(data))
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}
export function patch(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.patch(`${domain}${url}`, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

export function put(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.put(`${domain}${url}`, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}